import HeroBannerCarousal from '../../components/HeroBannerCarousal/HeroBannerCarousal';
import DefaultComponent from '../../components/defaultComponent/DefaultComponent';
import PromotionOverview from '../../components/PromotionOverview/PromotionOverview';
import ResourceOverview from '../../components/ResourceOverview/ResourceOverview';
import MePanel from '../../components/MePanel/MePanel';
import ProductCarousal from '../../components/ProductCarousal/ProductCarousal';
import { ComponentRegistry, ComponentType } from './types/propTypes';
const componentRegistry: ComponentRegistry = {
  [ComponentType.product_carousal_banner]: HeroBannerCarousal,
  [ComponentType.default]: DefaultComponent,
  [ComponentType.me_panel]: MePanel,
  [ComponentType.promotion_overview]: PromotionOverview,
  [ComponentType.resource_overview]: ResourceOverview,
  [ComponentType.product_carousel]: ProductCarousal,
  [ComponentType.a_point_product_carousel]: ProductCarousal,
};

export default componentRegistry;
